export default (storeState, {payload}) => {
  let newState = Object.assign({}, storeState);
  newState.headerSetting = payload;

  return newState;
};
